import { c as _c } from "react/compiler-runtime";
import { useIsMounted } from '@cc-shopping/hooks/useIsMounted';
import { Box, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { Rating } from 'src/features/product-card/NerdWalletRating/Rating';
import { StarRatingTooltip } from 'src/features/product-card/NerdWalletRating/StarRatingTooltip';
import { useCompareContext } from '../../../Context';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
import { RatingContainer } from './Rating.container';
export function ProductCardRating() {
  const $ = _c(30);
  const isMounted = useIsMounted();
  const {
    setShowStickyHeader
  } = useCompareContext();
  const {
    analytics,
    offer
  } = useCreditCardCompareOfferContext();
  const {
    reviewLink,
    starRating,
    starRatingTooltip,
    name,
    displayName,
    monetizable
  } = offer;
  const ratingRef = useRef(null);
  let t0;
  if ($[0] !== isMounted || $[1] !== setShowStickyHeader) {
    t0 = () => {
      const containerDivElement = ratingRef.current;
      if (isMounted && containerDivElement) {
        const rect = containerDivElement.getBoundingClientRect();
        if (rect.top < 0) {
          setShowStickyHeader(true);
        }
      }
    };
    $[0] = isMounted;
    $[1] = setShowStickyHeader;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== isMounted) {
    t1 = [isMounted];
    $[3] = isMounted;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: {
        sm: 2
      }
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "--star-rating-size": {
        xs: "16px",
        sm: "18px"
      },
      "--star-rating-gap": {
        xs: "6px",
        sm: "7px"
      },
      alignSelf: "center",
      marginY: "2px"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] !== starRating) {
    t4 = <Rating value={starRating} additionalStyles={t3} />;
    t5 = starRating && <Typography sx={{
      fontWeight: "700",
      paddingRight: {
        xs: 2,
        sm: 1
      },
      lineHeight: 1,
      fontSize: {
        xs: "14.5px",
        sm: "16px"
      }
    }}>{starRating.toFixed(1)}</Typography>;
    $[7] = starRating;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Box sx={t2}>{t4}{t5}</Box>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== analytics || $[15] !== displayName || $[16] !== monetizable || $[17] !== name || $[18] !== reviewLink || $[19] !== starRating || $[20] !== starRatingTooltip) {
    t8 = starRating && <Box sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: {
        sm: 2
      }
    }}><CtaLink target="_blank" href={reviewLink} analytics={analytics} parameterActions={[]} aria-label={`Read review of ${displayName || name}`} skipShoppingFinishedEvent={true}><Typography variant="text" sx={{
          fontSize: {
            xs: "14.5px",
            sm: "16px"
          }
        }}>NerdWallet rating</Typography></CtaLink>{starRatingTooltip && <StarRatingTooltip isMonetizing={monetizable.includes("yes_assumed")} />}</Box>;
    $[14] = analytics;
    $[15] = displayName;
    $[16] = monetizable;
    $[17] = name;
    $[18] = reviewLink;
    $[19] = starRating;
    $[20] = starRatingTooltip;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== starRating) {
    t9 = !starRating && <Typography variant="textSmall" sx={{
      color: "neutral.dark"
    }}>Not yet rated</Typography>;
    $[22] = starRating;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <Box sx={t7}>{t8}{t9}</Box>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t6) {
    t11 = <RatingContainer ratingRef={ratingRef}>{t6}{t10}</RatingContainer>;
    $[27] = t10;
    $[28] = t6;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}